/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { KTSVG } from '../../../../../_metronic/helpers';
import { LoadingSpan } from '../../Loadings/loadingSpan';
import { Loading } from '../../Loadings/loading';
import { useToast } from '../../Toats';
import { useAuth } from '../../../../modules/auth';
import { initialLetters } from '../../../../utils/initialLetters';
import { tempoPassado } from '../../../../utils/date';
import { deleteCommentOne, getCommentsService, postComment } from '../../../../services/commentsService';

type Props = {
  itemOrderOfService: any;
}

export function CommentsOS({itemOrderOfService}: Props) {
    const idService = itemOrderOfService && itemOrderOfService.id ? itemOrderOfService.id : "";
    const [content, setContent] = useState<string>("");
    const [isCardOpen, setIsCardOpen] = useState<boolean>(true);
    const [startComment, setStartComment] = useState<boolean>(false);
    const [loadingPost, setLoadingPost] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const { currentUser } = useAuth();

    const { data: comments = [], isLoading: loading, refetch } = useQuery(
        ["getCommentsOS", idService],
        async () => {
            const comments = await getCommentsService(idService);
            return comments;
        },
        {
          enabled: !!idService,
          onError: (error) => {
            console.log(error);
          },
        }
    )

    const cancelComment = () => {
        setContent("")
        setStartComment(false)
    }

    const postComments = async () => {
        if(!content.trim()) return;
        try {
            setLoadingPost(true)
            await postComment({
                content: content,
                idService: idService,
                idUser: currentUser && currentUser.id ? currentUser.id : ""
            });
            toggleToast("Sucesso ao comentar. ", "success");
            cancelComment()
        } catch (error) {
            console.log('erro', error)
            toggleToast("Erro ao comentar. ", "error")
        } finally {
            setLoadingPost(false)
            refetch()
        }
    }

    const deleteComment = async (id: string) => {
        try {
            setLoadingPost(true)
            await deleteCommentOne(id);
            toggleToast("Sucesso ao excluir comentário. ", "success");
        } catch (error) {
            console.log('erro', error)
            toggleToast("Erro ao excluir comentário. ", "error")
        } finally {
            setLoadingPost(false)
            refetch()
        }
    }

    const canDelete = (comment: any) => {
        if(!currentUser || !currentUser.role) return false;
        if(currentUser.role.slug !== "CLIENTE") return true;
        return !!(comment.user && comment.user.id === currentUser.id);
    }

  return (
    <div className='card'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          onClick={() => setIsCardOpen((prev) => !prev)}
          aria-expanded={isCardOpen}
          aria-controls='kt_os_details_comments'
        >
          <div className='card-title m-0' style={{justifyContent: 'space-between', width: '100%'}}>
            <h3 className='fw-bolder m-0'>Comentários ({comments.length})</h3>
          </div>
        </div>

        <div id='kt_os_details_comments' className={`collapse ${isCardOpen ? 'show' : ''}`}>
          <div className='card-body border-top p-9'>
            <div>
                <input
                    onClick={() => setStartComment(true)}
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    name='content'
                    placeholder='Digite um comentário'
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !loading && !loadingPost) {
                            e.preventDefault();
                            postComments();
                        }
                    }}
                />
                {startComment && (
                <div style={{width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '0.5rem', marginTop: '0.7rem'}}>
                    <button
                        type='button'
                        className='btn btn-sm btn-light'
                        onClick={cancelComment}
                    >
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr063.svg'
                            className='svg-icon-3 ms-0 me-2'
                        />
                        Cancelar
                    </button>
                    <button
                        type='button'
                        className='btn btn-sm btn-primary'
                        disabled={loading || loadingPost || !content.trim()}
                        onClick={postComments}
                    >
                        Comentar
                    {
                        loadingPost ?
                        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                        />
                    }
                    </button>
                </div>)}
            </div>

            <div className='border border-gray-300 border-dashed rounded p-4 mt-5' style={{maxHeight: '25rem', overflow: 'auto'}}>
                {loading && (
                    <div className='d-flex justify-content-center p-5'>
                        <Loading myClass='spinner-border' style={{width: '1.5rem', height: '1.5rem'}}/>
                    </div>
                )}

                {!loading && comments.length <= 0 && (
                    <div className='bg-light d-flex flex-column align-items-center justify-content-center p-5' style={{gap: '0.5rem'}}>
                        <KTSVG
                            path="/media/icons/duotune/general/gen004.svg"
                            className='svg-icon-3x me-1'
                        />
                        <span className='text-muted fw-semibold fs-7'>Sem comentários!</span>
                    </div>
                )}

                {!loading && comments.length > 0 && (
                    <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                        {comments.map((comment: any) => (
                            <div key={comment.id} className='d-flex' style={{alignItems: 'center', gap: '0.5rem'}}>
                                <div className='symbol symbol-30px symbol-circle'>
                                    <span className='symbol-label bg-light-primary text-primary fs-9 fw-bolder'>
                                        {comment.user && comment.user.name ? initialLetters(comment.user.name) : "?"}
                                    </span>
                                </div>
                                <div style={{width: '100%'}}>
                                    <div className='d-flex justify-content-start flex-column bg-light p-2'>
                                        <span className='text-dark fw-bold fs-8' style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                                            {comment.user && comment.user.name ? comment.user.name : "Não identificado"}
                                            {" . "}
                                            <span className='text-muted d-block fs-9'>
                                                {comment.created_at ? tempoPassado(comment.created_at) : "0h"}
                                            </span>
                                        </span>
                                        <span className='text-muted fw-semibold d-block fs-7'>
                                            {comment.content ? comment.content : ""}
                                        </span>
                                    </div>
                                </div>
                                {canDelete(comment) && (
                                    <div>
                                        <button
                                            type='button'
                                            disabled={loadingPost}
                                            onClick={() => deleteComment(comment.id)}
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                        >
                                            <KTSVG
                                                path='/media/icons/duotune/general/gen027.svg'
                                                className='svg-icon-3'
                                            />
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
          </div>
        </div>
    </div>
  );
}
